import { Outlet } from "react-router-dom";
import { useInit } from "@follosoft/react-components";

import { LanguageSelector } from "@/components/LanguageSelector.tsx";
import { getAccountLogo } from "@/utils/account-logo";
import { useFlow } from "@/contexts/FlowContext.tsx";
import { useContract } from "@/hooks/useContract";
import { useTranslation } from "react-i18next";

const isDev = import.meta.env.DEV;

export default function DefaultLayout() {
  const { contractId } = useFlow();
  const { account } = useInit();
  const { t } = useTranslation();
  const { data: contract } = useContract(contractId);

  // The contract's own company is the brand the customer is dealing with; the
  // account logo is only the subdomain-wide fallback while the contract loads.
  const logo =
    contract?.relationships?.company?.data?.attributes?.logo ??
    getAccountLogo(account);

  const handleDevLogout = () => {
    if(!contractId) return;
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <div className="max-w-full relative flex flex-col">
      <nav className="h-16 flex justify-between items-center px-4 gap-7 bg-white border-b-2 border-border">
        <>
          <div className={"h-10 md:block hidden"}>
            <img alt="logo" data-testid="logo" className="max-h-full h-full" src={logo} />
          </div>
          <div className={"w-[1px] h-10 bg-zinc-200 md:block hidden"} />
          <div
            className={"text-monochrome-800 text-lg leading-7 font-semibold"}
          >
            {t("fe.pages.flow.title")}
            <span
              className={"text-zinc-400 text-sm leading-5 font-semibold ml-2"}
            >
                #{contractId}
              </span>
          </div>
        </>
        <div className="flex-1 flex justify-end items-center gap-3">
           {isDev && (
            <button
              onClick={handleDevLogout}
              className=" cursor-pointer text-xs font-medium px-2.5 py-1 rounded-md border border-dashed border-orange-400 text-orange-500 hover:bg-orange-50 transition-colors"
              title="Dev only — clears session storage"
            >
              [DEV] Logout
            </button>
          )}
          <LanguageSelector />
        </div>
      </nav>
      <div className="max-w-7xl w-full mx-auto md:px-10 px-4 pt-8">
        <Outlet />
      </div>
    </div>
  );
}
